var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.013 3.035c.881-1.533 3.092-1.533 3.974 0l6.702 11.656c.879 1.528-.224 3.434-1.987 3.434H3.298c-1.763 0-2.866-1.906-1.987-3.434L8.013 3.035Zm2.89.623a1.042 1.042 0 0 0-1.806 0L2.394 15.314c-.399.695.102 1.561.904 1.561h13.404c.801 0 1.303-.866.903-1.56L10.903 3.657Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 6.875c.345 0 .625.28.625.625v3.333a.625.625 0 1 1-1.25 0V7.5c0-.345.28-.625.625-.625ZM10.426 13.701c.257.231.278.626.047.883l-.008.01a.625.625 0 1 1-.93-.837l.009-.01a.625.625 0 0 1 .882-.046Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangle);
export default ForwardRef;